module.exports = __webpack_public_path__ + "static/media/logo.40f2a432.png";